/**
 * Styled Components - Created by david on 03/04/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  background-color: #222;
`

export const Text = styled.div`
  color: #fff;
`

export const Icon = styled.img``

export const PopOverComp = styled.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  background: white;
  top: 56px;
  left: 0;
  height: 100vh;
  width: 100%;
  padding: 10px 12px;
  color: #5F6062;
  overflow-y: hidden;
`

export const overStyle = {
  width: '100%',
  paddingTop: 7,
  zIndex: '1000',
  position: 'fixed'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MobileMenu/styledComponents.tsx